import React, { useCallback } from 'react';
import { PropTypes } from 'prop-types';
import { IconButton, DialogContentText, Grid } from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import { RemoveCircleSharp as RemoveCircle } from '@material-ui/icons';
import classNames from 'classnames';
import { RemoveEntityConfirmationDialog } from '~/modules/common/components';
import { useDialogState } from '~/modules/common/hooks';
import SkillRating from '~/modules/resourcing/common/components/Skills/SkillRating';
import useStyles from './useStyles';

const deleteDialogResourceKeys = {
  header: 'skillInfoCard.deleteSkillDialog.removeUserDefinedSkill',
  actionButton: 'skillInfoCard.deleteSkillDialog.removeUserDefinedSkill'
};

export const MobileUserDefinedSkillRow = ({
  userDefinedSkill,
  classes: classesOverride,
  onUserDefinedSkillRemove,
  onUserDefinedSkillRatingUpdate,
  maxSkillLevel
}) => {
  const { formatMessage } = useIntl();
  const classes = useStyles({ classes: classesOverride });
  const {
    open: showRemoveDialog,
    openDialog: openRemoveDialog,
    closeDialog: closeRemoveDialog
  } = useDialogState(false);

  const onRemoveConfirmCallback = useCallback(
    () => onUserDefinedSkillRemove(userDefinedSkill),
    [onUserDefinedSkillRemove, userDefinedSkill]
  );

  const onUDSkillRatingUpdate = useCallback(
    ({ ratingIndex }) => {
      onUserDefinedSkillRatingUpdate({ userDefinedSkill, ratingIndex });
    },
    [onUserDefinedSkillRatingUpdate, userDefinedSkill]
  );

  return (
    <>
      {showRemoveDialog && (
        <RemoveEntityConfirmationDialog
          resourceKeys={deleteDialogResourceKeys}
          open={showRemoveDialog}
          onClose={closeRemoveDialog}
          onConfirm={onRemoveConfirmCallback}
        >
          <DialogContentText>
            {formatMessage({
              id: 'skillInfoCard.deleteSkillDialog.description'
            })}
          </DialogContentText>
        </RemoveEntityConfirmationDialog>
      )}
      <Grid container direction="row">
        <Grid item className={classes.cell} xs={11}>
          <span className={classNames(classes.skillName, classes.spacing)}>
            {userDefinedSkill.displayText}
          </span>
        </Grid>
        <Grid item className={classes.removeIconCell} xs={1}>
          <IconButton onClick={openRemoveDialog} className={classes.iconButton}>
            <RemoveCircle className={classes.removeIcon} />
          </IconButton>
        </Grid>
        <Grid item className={classes.cell} xs={12}>
          <span className={classNames(classes.title, classes.spacing)}>
            <FormattedMessage id="skillInfoCard.level" />
          </span>
          {Boolean(maxSkillLevel) && (
            <SkillRating
              skillAssignment={userDefinedSkill}
              onSkillRatingUpdate={onUDSkillRatingUpdate}
              className={classNames(
                classes.skillRatingContainer,
                classes.spacing
              )}
              editable
              maxSkillLevel={maxSkillLevel}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};

MobileUserDefinedSkillRow.propTypes = {
  classes: PropTypes.object,
  userDefinedSkill: PropTypes.object.isRequired,
  onUserDefinedSkillRemove: PropTypes.func,
  onUserDefinedSkillRatingUpdate: PropTypes.func,
  maxSkillLevel: PropTypes.number
};

export default MobileUserDefinedSkillRow;
